module.exports = __webpack_public_path__ + "img/BMG_Equine_Bone_Plate_D2.4f24d19c.jpg";